module.exports = __webpack_public_path__ + "img/phone.f07b1e45.svg";